module.exports = __webpack_public_path__ + "media/react/assets/images/logo-full-e0d8442915d5399f159ec5b9652446df.svg";